const Lock = ({ className }) => {
  return (
    <svg
      className={className}
      width='55'
      height='66'
      viewBox='0 0 55 66'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <mask
        id='mask0_2907_102907'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='10'
        y='32'
        width='44'
        height='23'
      >
        <path
          d='M11.3141 47.6072C10.4628 46.9783 10.6315 45.6592 11.6139 45.2649L42.2578 32.9641C42.693 32.7894 43.1877 32.8527 43.5649 33.1313L53.203 40.2514C53.4709 40.4493 53.4986 40.8396 53.2615 41.0734C47.2663 46.9841 39.6492 50.9792 31.3782 52.5509L20.7852 54.5638C20.4984 54.6183 20.2022 54.5441 19.975 54.3608L14.7428 50.1401L11.3141 47.6072Z'
          fill='#2538BF'
        />
      </mask>
      <g mask='url(#mask0_2907_102907)'>
        <circle
          cx='45.6373'
          cy='47.7863'
          r='22.3099'
          transform='rotate(66.7375 45.6373 47.7863)'
          fill='url(#paint0_linear_2907_102907)'
        />
      </g>
      <path
        d='M11.2181 55.8046L10.7769 31.9829V31.8054C10.7769 31.7772 10.7638 31.7507 10.7414 31.7336L0.554688 23.9829V48.3807C0.554688 48.41 0.568867 48.4374 0.592725 48.4543L11.0758 55.8798C11.1361 55.9225 11.2194 55.8785 11.2181 55.8046Z'
        fill='#0E72ED'
      />
      <path
        d='M43.762 18.2495L10.73 31.5689C10.5573 31.6385 10.4452 31.8073 10.4479 31.9935L10.7954 55.566C10.7994 55.8377 11.0412 56.0442 11.3101 56.0055L20.2126 54.7264C29.263 53.4261 37.6225 49.1484 43.9714 42.5687C44.0312 42.5067 44.0643 42.4238 44.0637 42.3377L43.8859 18.3324C43.8854 18.2688 43.821 18.2257 43.762 18.2495Z'
        fill='#648CFE'
      />
      <path
        d='M0.554688 23.9829L32.7211 10.5837C33.1598 10.401 33.6622 10.462 34.0444 10.7443L43.693 17.8721C43.9505 18.0623 43.9772 18.4375 43.7492 18.6623C37.7538 24.5733 30.0773 28.4858 21.7714 29.8638L10.9919 31.6522C10.7354 31.6947 10.4726 31.6316 10.2634 31.4771L5.21305 27.7462L0.554688 23.9829Z'
        fill='#A8CCF8'
      />
      <path
        d='M10.0836 13.013C9.74644 15.4531 10.0417 24.167 10.0797 25.2419C10.0822 25.313 10.1073 25.3823 10.1524 25.4372C11.9371 27.6139 15.1821 26.8498 16.0099 25.4228C16.0371 25.376 16.0492 25.3227 16.0492 25.2686V16.1314C16.0492 14.9638 17.0679 11.5578 17.9474 10.3014C18.8269 9.04496 19.8455 7.04741 24.9976 5.6916C29.1137 4.60842 30.0568 7.04078 30.0143 8.39769L30.0142 8.40478V17.6085C30.0142 17.7056 30.0548 17.7962 30.132 17.8552C31.3251 18.7665 34.3347 19.1997 34.8847 17.1211C34.8917 17.0948 34.8951 17.0681 34.8951 17.0409V6.09834C34.8951 2.02901 30.9382 0.457084 29.3483 0.135179L29.3451 0.134523C29.3392 0.133308 29.3365 0.132768 29.3292 0.131918C29.0602 0.100705 21.1204 -0.772164 14.7583 4.17621C11.5343 6.68375 10.4432 10.411 10.0836 13.013Z'
        fill='#F0F2FF'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M31.6492 39.5566C32.5588 38.4613 33.1764 36.9922 33.1764 35.7131C33.1764 33.8533 31.8707 33.0995 30.2601 34.0294C28.6494 34.9593 27.3438 37.2208 27.3438 39.0806C27.3438 40.2938 27.8994 41.0364 28.7328 41.148L28.7328 46.7777L31.6492 45.0939L31.6492 39.5566Z'
        fill='#252A30'
      />
      <mask
        id='mask1_2907_102907'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='27'
        y='33'
        width='7'
        height='14'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M31.6492 39.5566C32.5588 38.4613 33.1764 36.9922 33.1764 35.7131C33.1764 33.8533 31.8707 33.0995 30.2601 34.0294C28.6494 34.9593 27.3438 37.2208 27.3438 39.0806C27.3438 40.2938 27.8994 41.0364 28.7328 41.148L28.7328 46.7777L31.6492 45.0939L31.6492 39.5566Z'
          fill='#F4D176'
        />
      </mask>
      <g mask='url(#mask1_2907_102907)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M30.2117 38.8376C31.1213 37.7423 31.7389 36.2732 31.7389 34.9941C31.7389 33.1343 30.4332 32.3805 28.8226 33.3104C27.2119 34.2403 25.9063 36.5018 25.9063 38.3616C25.9063 39.5748 26.4619 40.3174 27.2953 40.429L27.2953 46.0587L30.2117 44.3749L30.2117 38.8376Z'
          fill='#FFBF39'
        />
      </g>
      <mask
        id='mask2_2907_102907'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='28'
        y='31'
        width='19'
        height='20'
      >
        <path
          d='M46.6814 31.8064L31.1182 33.6043L28.7305 38.9981V46.776L46.6814 50.6847V31.8064Z'
          fill='#FFBF39'
        />
      </mask>
      <g mask='url(#mask2_2907_102907)'>
        <circle
          opacity='0.6'
          cx='27.1385'
          cy='41.4588'
          r='14.4225'
          transform='rotate(51.2399 27.1385 41.4588)'
          fill='url(#paint1_linear_2907_102907)'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_2907_102907'
          x1='34.4823'
          y1='67.3075'
          x2='59.0232'
          y2='28.823'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#2538BF' />
          <stop
            offset='0.927083'
            stopColor='#2538BF'
            stopOpacity='0'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_2907_102907'
          x1='19.9273'
          y1='54.0785'
          x2='35.7921'
          y2='29.1997'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFBF39' />
          <stop
            offset='1'
            stopColor='#FFBF39'
            stopOpacity='0'
          />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default Lock
